import { render, staticRenderFns } from "./iForm.vue?vue&type=template&id=770f79f6&scoped=true&"
import script from "./iForm.vue?vue&type=script&lang=js&"
export * from "./iForm.vue?vue&type=script&lang=js&"
import style0 from "./iForm.vue?vue&type=style&index=0&id=770f79f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770f79f6",
  null
  
)

export default component.exports